export default __webpack_public_path__ + "static/media/ellipse1.0a5f1e97.svg";